<template>
  <div class="questionnaire-field">
    <!-- List de opções -->
    <v-col v-if="field.field_type == fieldType.LIST">
      <div class="mb-2 font-14 font-weight-medium">
        {{ fieldName(field) }}
      </div>
      <v-radio-group
        :disabled="disabled"
        v-model="field.value"
        class="mt-0 pt-0"
      >
        <div
          v-for="(option, optionIndex) in field.options"
          :key="`option-${optionIndex}`"
        >
          <v-radio
            :label="option.value"
            :value="option.value"
          ></v-radio>
          <div
            v-for="(rule, ruleIndex) in option.rules"
            :key="`tip-option-rule-index-${ruleIndex}`"
            class="tips"
          >
            <Tip v-if="rule.tip" v-show="field.value === option.value" :msg="rule.tip"></Tip>
          </div>
        </div>
      </v-radio-group>
    </v-col>

    <!-- v-model="field.value" -->
    <v-col v-if="field.field_type == fieldType.CHECKBOX">
      <v-checkbox
        :disabled="disabled"
        dense
        outlined
        v-model="field.value"
        :label="fieldName(field)"
        hide-details
      ></v-checkbox>
      <div
        v-for="(option, optionIndex) in field.options"
        :key="`option-${optionIndex}`"
      >
        <div
          v-for="(rule, ruleIndex) in option.rules"
          :key="`tip-option-rule-index-${ruleIndex}`"
          class="tips mt-4"
        >
          <Tip v-if="rule.tip" v-show="field.value === option.value" :msg="rule.tip"></Tip>
        </div>
      </div>
    </v-col>

    <!-- texto curto -->
    <v-col v-if="field.field_type == fieldType.SHORT_TEXT">
      <div class="mb-2 font-14 font-weight-medium">
        {{ fieldName(field) }}
      </div>
      <v-text-field
        v-model="field.value"
        :disabled="disabled"
        background-color="#fff"
        hide-details
        dense
        outlined
      >
      </v-text-field>
    </v-col>

    <!-- texto longo -->
    <v-col v-if="field.field_type == fieldType.LONG_TEXT">
      <div class="mb-2 font-14 font-weight-medium">
        {{ fieldName(field) }}
      </div>
      <v-textarea
        v-model="field.value"
        :disabled="disabled"
        hide-details
        background-color="#fff"
        dense
        outlined
      >
      </v-textarea>
    </v-col>

    <!-- número inteiro -->
    <v-col v-if="field.field_type == fieldType.INT">
      <div class="mb-2 font-14 font-weight-medium">
        {{ fieldName(field) }}
      </div>
      <v-text-field
        dense
        type="number"
        hide-details
        :disabled="disabled"
        step="1"
        min="0"
        background-color="white"
        v-model="field.value"
        :rules="[$rules.int, $rules.greaterThanZero]"
        outlined
        name="username"
      ></v-text-field>
    </v-col>

    <!-- escala -->
    <!-- <v-col v-if="field.field_type == 10">
                <div class="mb-2 font-14 font-weight-medium">{{ fieldName(field) }}</div>
                <v-slider thumb-label="always"></v-slider>
              </v-col> -->

    <!-- data -->
    <v-col v-if="field.field_type == fieldType.DATE">
      <div class="mb-2 font-14 font-weight-medium">
        {{ fieldName(field) }}
      </div>
      <v-menu
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
        v-model="field.open"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            dense
            outlined
            background-color="white"
            persistent-hint
            append-icon="mdi-calendar"
            v-bind="attrs"
            :value="field.value | njDate"
            :disabled="disabled"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="field.value"
          @input="field.open = false"
          no-title
        ></v-date-picker>
      </v-menu>
    </v-col>

    <!-- subfields -->
    <QuestionnaireSubFields
      :field="field"
      :disabled="disabled"
    ></QuestionnaireSubFields>
  </div>
</template>
<script type="text/javascript">
import { MAP } from '@/enumerations/questionnaires_enum'
export default {
  name: 'QuestionnaireField',
  components: {
    QuestionnaireSubFields: () => import('./questionnaire_sub_fields'),
    Tip: () => import('./tip'),
  },

  props: {
    field: {
      type: Object,
      default: () => ({ value: null }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  
  data() {
    return {
      fieldType: MAP,
    }
  },

  methods: {
    fieldName(field) {
      return field.obrigatorio ? `${field.name} *` : field.name
    },
  },
}
</script>
<style scoped lang="scss">
.questionnaire-field {
  width: 100%;

  .v-radio {
    width: fit-content;
    margin-bottom: 12px;
  }
}
</style>
